module.exports = __webpack_public_path__ + "img/pp-vac.2ed866cd.png";